import { Spinner } from './Spinner';

interface FullScreenLoaderProps {
  message?: string;
}

export function FullScreenLoader({ message = 'Загружаем карту Италии…' }: FullScreenLoaderProps) {
  return (
    <div className="fixed inset-0 z-[2000] flex flex-col items-center justify-center gap-4 bg-white">
      <Spinner size="lg" />
      <p className="text-sm text-slate-500">{message}</p>
    </div>
  );
}
